<template>
  <div>
    <!-- Apps Button -->
    <div class="apps-button" @click="showModal">
      <span class="btn-icon-wrapper">
        <svg
          viewBox="0 0 14 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="btn-icon-svg"
          width="10"
        >
          <path
            d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
            fill="currentColor"
          ></path>
        </svg>

        <svg
          viewBox="0 0 14 15"
          fill="none"
          width="10"
          xmlns="http://www.w3.org/2000/svg"
          class="btn-icon-svg-svg btn-icon-svg-copy"
        >
          <path
            d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
            fill="currentColor"
          ></path>
        </svg>
      </span>
      Explore All AI Apps
    </div>

    <!-- Modal -->
    <div
      class="modal"
      :class="[
        { show: showOptions.modal },
        { 'apps-loaded': appsSuite.length > 0 },
      ]"
    >
      <!-- Close -->
      <unicon name="times" class="btn-close" @click="closeModal"></unicon>

      <!-- Apps -->
      <div v-if="appsSuite.length > 0" class="apps-wrapper">
        <!-- Info -->
        <div class="info-wrapper">
          <h3 class="section-title">AI Apps Toolkit for Zendesk</h3>
          <p>Macha's apps help unlock AI for your workflows and agents</p>
        </div>

        <div class="apps-list">
          <!-- App -->
          <div
            v-for="app in appsSuite"
            :key="app.key"
            class="app"
            @click="gotoApp(app)"
          >
            <img :src="getAppIcon(app.appIcon)" :alt="app.title" />
            <span class="title">{{ app.title }}</span>

            <!-- Download status -->
            <div v-if="app.hasDownloaded" class="downloaded table-tag green">
              <unicon name="check"></unicon>
              <span>Downloaded</span>
            </div>
            <div v-else class="downloaded table-tag zendesk zendesk-link">
              <unicon name="external-link-alt"></unicon>
              <span>View on Zendesk</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Pre Loader -->
      <PreLoader v-else :show="true" class="pre-loader"></PreLoader>
    </div>
    <div
      class="bg-overlay light"
      :class="{ show: showOptions.modal }"
      @click="closeModal"
    ></div>
  </div>
</template>

<script>
// Libraries
import _ from "lodash";

// Components
import PreLoader from "@/components/loaders/PreLoader";

// Services
import { TranslationsAppService } from "@/services";

export default {
  name: "AppsPromotion",
  data() {
    return {
      lodash: _,
      showOptions: {
        modal: false,
      },
      apps: [
        {
          key: "ticketTranslations",
          title: "Ticket Translations AI",
          route: "translations",
          zendeskAppId: "1166071",
          appIcon: "ticket-translations.png",
          hasDownloaded: false,
          app: {},
        },
      ],
      meta: {
        title: "Macha AI Apps",
        description: "",
      },
    };
  },

  components: {
    PreLoader,
  },

  computed: {
    user() {
      return this.$store.getters.user.user;
    },
    company() {
      return this.$store.getters.company;
    },
    appsSuite() {
      return this.$store.getters.appsSuite;
    },
  },

  async created() {
    this.getAppsSuite();
  },
  methods: {
    async getAppsSuite() {
      if (this.appsSuite.length === 0) {
        const response = { ticketTranslations: {} };
        const data = { companyId: this.company._id };

        response.ticketTranslations =
          await TranslationsAppService.CompanyService.GetCompany(data);

        for (const [key, app] of Object.entries(response)) {
          if (app?.data?.companyId) {
            const selectedApp = this.apps.find((a) => a.key === key);
            selectedApp.app = app.data;
            selectedApp.hasDownloaded = true;
          }
        }

        this.$store.commit("updateAppsSuite", this.apps);
      }

      this.apps = this.appsSuite;
    },

    // Get the Zendesk marketplace app link
    getZendeskMarketplaceLink(appId) {
      return `https://www.zendesk.com/in/marketplace/apps/support/${appId}`;
    },

    // Click action
    gotoApp(app) {
      if (!app.hasDownloaded) {
        window
          .open(this.getZendeskMarketplaceLink(app.zendeskAppId), "_blank")
          .focus();
      }
    },

    // Get app icon
    getAppIcon(icon) {
      let iconURL = `/assets/images/apps/${icon}`;
      return iconURL;
    },

    showModal() {
      this.showOptions.modal = true;
    },

    closeModal() {
      this.showOptions.modal = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.modal {
  display: block;
  width: 35rem;
  padding: 2rem;
  bottom: 0;
  top: auto;
  transform: translateY(120%) translateX(-50%);
  border-radius: 2rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  overflow: hidden;
  transition: all 0.3s;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.6;
    pointer-events: none;
    z-index: -1;
    background: radial-gradient(
      circle at bottom left,
      #ffffff 0%,
      transparent 70%
    );
    transition: all 0.3s;
  }

  &.apps-loaded::before {
    background: radial-gradient(
      circle at bottom left,
      #edd6ff 0%,
      transparent 70%
    );
  }

  &.show {
    transform: translateY(0%) translateX(-50%);
  }
}

.pre-loader {
  flex: 1;
  margin: 3rem 15%;
  max-width: 60%;
}

.apps-wrapper {
  width: 100%;
  text-align: center;

  .info-wrapper {
    margin-bottom: 3rem;

    .section-title {
      font-size: $mediumFontSize;
      margin-bottom: 0.75rem;
    }

    p {
      font-size: $smallFontSize;
      color: $greyColor;
      opacity: $mediumOpacity;
    }
  }
}

.apps-list {
  gap: 2rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.app {
  text-align: center;
  flex: 0 0 calc(33% - 2rem);

  img {
    display: block;
    width: 5rem;
    margin: 0 auto 1rem;
    border-radius: 0.85rem;
    border: 1px solid #ececec;
    transform: translateY(0);
    transition: all 0.3s;
  }

  .title {
    font-size: $smallFontSize;
    font-weight: $mediumFontWeight;
  }

  .btn {
    opacity: 0;
    margin: auto;
    padding: 5px;
    white-space: nowrap;
    margin-top: 2rem;
    justify-content: center;
    width: fit-content;
    padding-right: 0.75rem;
  }

  .downloaded {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    justify-content: center;
    border-radius: 0.5rem;
    margin: auto;
    padding: 0.15rem 0.5rem;
    gap: 0.15rem;

    margin-top: 0.25rem;

    .unicon ::v-deep svg {
      width: 1rem;
      height: auto;
      fill: lighten($greyColor, 15%);
      transform: translateY(1px);
    }

    span {
      font-size: $smallestFontSize;
      font-weight: $mediumFontWeight;
    }

    &.green {
      background-color: lighten($tagGreenBackgroundColor, 5%);

      .unicon ::v-deep svg {
        fill: darken($greenColor, 20%);
      }
    }
  }
}

.zendesk-link {
  cursor: pointer;

  ::v-deep .unicon {
    svg {
      width: 0.75rem !important;
      margin-right: 0.25rem;
      fill: $tagZendeskTextColor !important;
    }
  }
}

.btn-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  cursor: pointer;

  ::v-deep svg {
    fill: $whiteColor;
    width: 1.65rem;
    height: 1.65rem;
    background: $blackColor;
    border: 1px solid lighten($blackColor, 10%);
    border-radius: 0.25rem;
    padding: 0.25rem;
    border-radius: 50%;

    &:hover {
      border: 1px solid lighten($blackColor, 60%);
    }
  }
}

.apps-button {
  position: fixed;
  z-index: 10;
  bottom: 1.5rem;
  right: 6.5rem;
  line-height: 1;
  text-decoration: none;
  display: inline-flex;
  border: none;
  cursor: pointer;
  align-items: center;
  gap: 0.75rem;
  background-color: $blackColor;
  color: $whiteColor;
  border-radius: 10rem;
  font-weight: $mediumFontWeight;
  font-size: $smallFontSize;
  padding: 0.75rem 1.5rem;
  padding-left: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background-color 0.3s;

  .btn-icon-wrapper {
    flex-shrink: 0;
    width: 25px;
    height: 25px;
    position: relative;
    color: $blackColor;
    background-color: $whiteColor;
    border-radius: 50%;
    display: grid;
    place-items: center;
    overflow: hidden;
  }

  .btn-icon-svg-copy {
    position: absolute;
    transform: translate(-150%, 150%);
  }

  &:hover {
    background-color: $purpleColor;

    .btn-icon-wrapper {
      color: $purpleColor;
    }

    .btn-icon-svg:first-child {
      transition: transform 0.3s ease-in-out;
      transform: translate(150%, -150%);
    }

    .btn-icon-svg-copy {
      transition: transform 0.3s ease-in-out 0.1s;
      transform: translate(0);
    }
  }
}
</style>
